
import { Component, Vue } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import { ValidationObserver } from 'vee-validate';
import { BlockStore, CommonStore } from '@/store/modules';
import LocationInputMap from '@/components/Forms/Components/LocationInputMap.vue';
import { AssignCrop } from '@/store/models/block';

@Component({
  components: {
    ValidationObserver,
    QvInput,
    QvSelect,
    LocationInputMap
  }
})
export default class BlockForm extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  assignCrop: AssignCrop = {} as AssignCrop;
  deleteDialog = false;

  allSelected: boolean | null = false;

  checkAll(value: boolean | null) {
    if (value) {
      this.$set(
        this.assignCrop,
        'blocks',
        this.blocks.map(option => option.value)
      );
      return;
    }
    this.$set(this.assignCrop, 'blocks', []);
  }

  checkVals(value: string[]) {
    this.allSelected =
      value.length > 0 && value.length < this.blocks.length
        ? null
        : value.length === this.blocks.length
        ? true
        : false;
  }

  get selectedFarmBlock() {
    return CommonStore.SelectedFarmBlock;
  }

  get crops() {
    return BlockStore.Crops.map(x => {
      return { value: x.id, label: `${x.cropTypeName} (${x.varietyName})` };
    });
  }

  get blocks() {
    return BlockStore.SimpleBlocks.filter(
      x => x.farm == this.selectedFarmBlock.farmId
    ).map(x => {
      return { value: x.id, label: x.name };
    });
  }

  onSubmit() {
    BlockStore.assignCrop(this.assignCrop).then(res => {
      this.$q.notify({
        message: res.message,
        type: 'positive'
      });
      this.$router.push({ name: 'BlockList' });
    });
  }

  onReset() {
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
      this.$router.push({ name: 'BlockList' });
    });
  }

  async created() {
    BlockStore.getSimpleBlocks();
    BlockStore.getAllCrops();
    if (this.$route.params.blockId) {
      this.allSelected = null;
      const blockId = Number(this.$route.params.blockId);
      await BlockStore.getBlockById(blockId);
    }
  }
}
